import * as create from "./create";
import * as edit from "./edit";
import * as detail from "./detail";

import * as api from "services/api";
import { getErrors } from "helpers/error";
import { Callback } from "Types/Callback";
import IInvoice from "../../../Types/Invoice";

export const GET_INVOICES = "[INVOICES] GET_INVOICES";
export const GET_INVOICES_SUCCESS = "[INVOICES] GET_INVOICES_SUCCESS";
export const GET_INVOICES_FAILED = "[INVOICES] GET_INVOICES_FAILED";

export const GET_INVOICING = "[INVOICES] GET_INVOICING";
export const GET_INVOICING_SUCCESS = "[INVOICES] GET_INVOICING_SUCCESS";
export const GET_INVOICING_FAILED = "[INVOICES] GET_INVOICING_FAILED";

export const SET_VALUE = "[INVOICES EDIT] SET_VALUE";
export const CLEAR_VALUES = "[INVOICES EDIT] CLEAR_VALUES";

export { create, edit, detail };

export function setValue(payload: any) {
	return { type: SET_VALUE, payload };
}

export function clearValues() {
	return { type: CLEAR_VALUES };
}

export function getInvoices(
	skip?: number,
	take: number = 10,
	filter?: any[],
	sort?: string,
	desc?: boolean,
	toExport?: boolean,
	callback?: Callback<IInvoice[]>
) {
	return async (dispatch: any, getState: any) => {
		dispatch({ type: GET_INVOICES });

		try {
			const { login } = getState();

			const response = await api.sendGet(
				`/Invoice?skip=${skip}&take=${take}&sort=${sort}&desc=${desc}${
					filter || "&filters=null"
				}`,
				{
					Authorization: `Bearer ${login.token}`
				}
			);

			const result = await response.json();

			if (result.isValid) {
				if (toExport) {
					dispatch(setValue({ loading: false }));
				} else {
					dispatch({
						type: GET_INVOICES_SUCCESS,
						payload: result.model
					});

					if (result.params)
						dispatch(
							setValue({
								pages: Math.ceil(result.params.count / (take || 10)),
								...result.params
							})
						);
				}

				callback && callback(null, result.model);
			} else {
				const errors = getErrors(result.errors);

				dispatch({
					type: GET_INVOICES_FAILED,
					payload: errors
				});
				callback && callback(errors);
			}
		} catch (error) {
			return dispatch({
				type: GET_INVOICES_FAILED,
				payload: {
					error: "Connection error"
				}
			});
		}
	};
}

export function getInvoicing(
	skip?: number,
	take: number = 10,
	filter?: any[],
	sort?: string,
	desc?: boolean,
	toExport?: boolean,
	callback?: Callback<IInvoice[]>
) {
	return async (dispatch: any, getState: any) => {
		dispatch({ type: GET_INVOICING });

		try {
			const { login } = getState();

			const response = await api.sendGet(
				`/Invoice/Info?skip=${skip}&take=${take}&sort=${sort}&desc=${desc}${
					filter || "&filters=null"
				}`,
				{
					Authorization: `Bearer ${login.token}`
				}
			);

			const result = await response.json();

			if (result.isValid) {
				if (toExport) {
					dispatch(setValue({ loading: false }));
				} else {
					dispatch({
						type: GET_INVOICING_SUCCESS,
						payload: result.model
					});

					if (result.params)
						dispatch(
							setValue({
								pages: Math.ceil(result.params.count / (take || 10)),
								...result.params
							})
						);
				}

				callback && callback(null, result.model);
			} else {
				const errors = getErrors(result.errors);

				dispatch({
					type: GET_INVOICING_FAILED,
					payload: errors
				});
				callback && callback(errors);
			}
		} catch (error) {
			return dispatch({
				type: GET_INVOICING_FAILED,
				payload: {
					error: "Connection error"
				}
			});
		}
	};
}
